import ReactGA from "react-ga4";
import posthog from "posthog-js";

export const initializeAnalytics = () => {
  const hasConsent = document.cookie.includes("secureShopCookieConsent=true");

  if (hasConsent) {
    if (!sessionStorage.getItem("GA_initialized")) {
      ReactGA.initialize(process.env.REACT_APP_GA4);
      ReactGA.send("pageview");
      sessionStorage.setItem("GA_initialized", "true");
    }
  } else {
    console.error("Analytics blocked (No Consent)");
  }
};

export const trackPageView = (path) => {
  const hasConsent = document.cookie.includes("secureShopCookieConsent=true");

  if (hasConsent) {
    if (!sessionStorage.getItem(`viewed_${path}`)) {
      ReactGA.send({ hitType: "pageview", page: path });
      sessionStorage.setItem(`viewed_${path}`, "true");
    }
  } else {
    console.warn("Analytics blocked (No Consent)");
  }
};
